import React, { useEffect } from "react";
import "./CountdownTimer.css";

interface CountdownTimerProps {
  targetDate: number;
}

declare global {
  interface Window {
    FlipDown: any; // Extend the Window interface to include FlipDown
  }
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ targetDate }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://pbutcher.uk/flipdown/js/flipdown/flipdown.js";
    script.async = true;
    script.onload = () => {
      const toDayFromNow = targetDate;
      const flipdown = new window.FlipDown(toDayFromNow).start().ifEnded(() => {
        const flipdownElement = document.querySelector(".flipdown");
        if (flipdownElement) {
          flipdownElement.innerHTML = `<h2>Timer is ended</h2>`;
        }
      });

      // Apply the color change after the FlipDown library has rendered the elements
      const applyColorChanges = () => {
        const elements = document.querySelectorAll(
          ".flipdown .rotor-leaf-front, .flipdown .rotor-leaf-rear, .flipdown .rotor-top, .flipdown .rotor-bottom, .flipdown .separator, .flipdown .rotor-group-heading:before",
        );
        elements.forEach((element) => {
          const el = element as HTMLElement;
          el.style.color = "white";
        });

        // Apply color change to pseudo-elements
        const rotorGroups = document.querySelectorAll(".flipdown .rotor-group");
        rotorGroups.forEach((rotorGroup) => {
          const rg = rotorGroup as HTMLElement;
          rg.style.setProperty("--pseudo-before-bg", "white", "important");
          rg.style.setProperty("--pseudo-after-bg", "white", "important");
        });
      };

      // Run this function after FlipDown has finished rendering
      const flipdownElement = document.querySelector(".flipdown");
      if (flipdownElement) {
        const observer = new MutationObserver(applyColorChanges);
        observer.observe(flipdownElement, { childList: true, subtree: true });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [targetDate]);

  return (
    <div className="count-down">
      <div className="flipdown" id="flipdown"></div>
    </div>
  );
};

export default CountdownTimer;
